import { FormlyFieldConfig, FormlyFormOptions } from '@ngx-formly/core';
import { WebhookPlainModel } from '@parashift/shared/models';
import { Topics } from '@parashift/shared/constants';
import { BasicForm } from './../formly/basic.form';

export class WebhooksEditForm extends BasicForm {
  constructor(public model: WebhookPlainModel, public options: FormlyFormOptions = {}, public topics = []) {
    super(model as WebhookPlainModel, options);
    this.options.formState = {
      ...this.options.formState,
      model: this.model
    };
    this.topics = topics;
  }

  initFields() {
    this.fields = [
      {
        wrappers: ['card-wrapper'],
        props: {
          label: 'Webhook'
        },
        fieldGroup: [
          {
            fieldGroupClassName: 'row',
            fieldGroup: [
              {
                className: 'col-sm-12',
                key: 'active',
                type: 'checkbox',
                props: {
                  label: $localize `:@@components.webhooks.is_active:is active`
                }
              },
              {
                className: 'col-sm-12',
                key: 'name',
                type: 'input',
                props: {
                  type: 'text',
                  label: $localize `:@@components.webhooks.webhook_name:Webhook name`,
                  required: true
                }
              },
              {
                className: 'col-sm-12',
                key: 'url',
                type: 'input',
                props: {
                  type: 'text',
                  label: $localize `:@@components.webhooks.webhook_url:Webhook URL`,
                  required: true
                }
              }
            ]
          }
        ]
      },
      {
        wrappers: ['card-wrapper'],
        props: {
          label: $localize `:@@components.webhooks.headers:Headers`
        },
        fieldGroup: [
          {
            fieldGroupClassName: 'row',
            fieldGroup: [
              {
                className: 'col-sm-12',
                key: 'headers',
                type: 'repeat-section',
                props: {
                  labelAdd: $localize `:@@components.webhooks.add_new_header:Add new header`,
                  btnClass: 'btn-xs'
                },
                fieldArray: {
                  fieldGroupClassName: 'row',
                  fieldGroup: [
                    {
                      className: 'col-sm-4',
                      key: 'name',
                      type: 'input',
                      defaultValue: '',
                      props: {
                        type: 'text',
                        label: $localize `:@@components.webhooks.header_name:Name`,
                        required: true
                      }
                    },
                    {
                      className: 'col-sm-8',
                      key: 'value',
                      type: 'input',
                      defaultValue: '',
                      props: {
                        type: 'text',
                        label: $localize `:@@components.webhooks.header_value:Value`,
                        required: true
                      }
                    }
                  ]
                }
              }
            ]
          }
        ]
      },
      {
        wrappers: ['card-wrapper'],
        props: {
          label: $localize `:@@components.webhooks.topics:Topics`,
          class: 'pb-3'
        },
        fieldGroup: [
          {
            key: 'topics',
            wrappers: ['empty-wrapper'],
            fieldGroupClassName: 'row',
            fieldGroup: [].concat(...Topics['pdc'].map(item => {
              const fields = [];
              let i = 0;

              item.topics.forEach(slug => {
                const topic = this.topics.find(t => t.slug === slug);

                if (topic) {
                  const field =  {
                    className: 'col-sm-12 multiple-checkboxes',
                    key: topic.id,
                    type: 'checkbox',
                    defaultValue: topic.checked,
                    props: {
                      label: topic.name,
                      indeterminate: false
                    }
                  };

                  if (i === 0) {
                    field['wrappers'] = ['headline-wrapper'];
                    field.props['headlineWrapperText'] = item.title;
                  }

                  fields.push(field);
                  i++;
                }
              });

              return fields;
            }))
          }
        ]
      }
    ] as FormlyFieldConfig[];
  }
}
